module.exports = __webpack_public_path__ + "static/savannah-c6ea28a5acf5106482cd8ff7798c1249.png";